export const REPORTS_NAMESPACE_TRANSLATIONS = {
  generateReport: {
    title: "Generare Rapoarte",
    description:
      "Generați rapoarte despre animalele din fermǎ cu informații legate de rasǎ, specie, sex şi datele relevante ale acestora.",
    note: "Rapoartele vor fi disponibile mai jos după generare, aceasta poate dura pana la 15 secunde.",
    pending: "Se generează raportul...",
    success: "Raportul a fost generat cu succes!",
    error: "Eroare la generarea raportului. Încercați din nou.",
    button: "Generează raport animale",
    buttonGenerating: "Se generează...",
  },

  individualAnimalReports: {
    title: "Rapoarte Individuale Animale",
    description:
      "Generați rapoarte detaliate despre un animal, reproducere, sănătate și productivitate.",
    note: "Rapoartele vor fi disponibile mai jos după generare, aceasta poate dura pana la 15 secunde.",
    button: "Generează raport animal",
  },

  filters: {
    all: "Toate rapoartele",
    animal: "Rapoarte animale",
    financial: "Rapoarte financiare",
    production: "Rapoarte producție",
  },

  status: {
    pending: "În așteptare",
    processing: "Se procesează",
    completed: "Completat",
    failed: "Eșuat",
  },
}
